const SocketEvent = {
  ORGANIZATION_CREATION_EVENT_NAME: 'Organization Creation',
};

export default SocketEvent;
